module.exports = __webpack_public_path__ + "static/media/holcim-plus.aabc092e.svg";